// import React from 'react';

// import { Icon } from "trimble-terra/Icon"
import { Icon } from "trimble-terra"

export interface Testimonial {
  quote?: string
  attributionName?: string
  attributionQualification?: string
}

export const Testimonial = ({
  quote,
  attributionName,
  attributionQualification,
}: Testimonial) => (
  <div className="rc-testimonial bg-mxpGray1">
    <div className="rc-testimonial__inner-wrap">
      <div className="rc-testimonial__quote-mark mr-12">
        <Icon type="t2u-quotation" size={40} />
      </div>
      <div className="rc-testimonial__content">
        <div className="rc-testimonial__quote mb-10">{quote}</div>
        <div className="rc-testimonial__attribution">
          <div className="rc-testimonial__attribution-name">
            — {attributionName}
          </div>
          <div className="rc-testimonial__attribution-qualification">
            {attributionQualification}
          </div>
        </div>
      </div>
    </div>
  </div>
)
